import { SERVER_ADDR, SLEEP_TIME } from '../../../constants';

export const uploadFiles = (file, name, folderName) => async (dispatch, getState, api) => {
  try {
    let matches = file.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
    const res = await api
      .post(`${SERVER_ADDR}uploadFiles`, { data: { file: matches[2], name, folderName }});

    return res.body;
  } catch (e) {
    console.log(e);
    return e;
  }
}

export const resetMessage = (type) => (dispatch) => {
  setTimeout(() => {
    dispatch({
      type: type,
      message: null
    })
  }, SLEEP_TIME);
}

export const broadcastMessage = (formData) => async (dispatch, getState, api) => {
  try {
    const email = getState().user.email;
    formData.userEmail = email;

    if (formData.postImages && formData.postImages.length > 0) {
      const images = [];
      formData.postImages.forEach(f => {
        images.push(f.name);
      });

      formData.images = images;
      delete formData.postImages;
    }

    const res = await api
      .post(`${SERVER_ADDR}broadcast`, { data: formData });
    
    return res;
  } catch (e) {
    console.log(e);
  }
}